import TeaserLinks from "components/TeaserLinks"

const ReferencesList = ({ references: data, content }) => {
  const hasData = data.length > 0
  const caseStudies = hasData ? data : null

  if (!caseStudies) return null

  const modifiedCaseStudies = caseStudies.map(
    ({
      title,
      slug,
      reference_images: referenceImages,
      hero_headline,
      hero_description,
      full_width,
      image,
      mobile_image,
    }) => ({
      link_link: `/referenzen/${slug}`,
      link_image:
        image || (referenceImages?.length > 0 ? referenceImages[0] : null),
      link_text: hero_description,
      dynamic_headline: hero_headline || title,
      headline_type: "h2",
      headline_appearance: "h2",
      full_width,
      mobile_image,
    })
  )

  return (
    <TeaserLinks
      data={{
        teasers: modifiedCaseStudies,
        display_type: { value: "fancy-grid" },
      }}
      content={content}
    />
  )
}

export default ReferencesList
